module.exports = __webpack_public_path__ + "img/zz6.e03ed51e.png";